export default __webpack_public_path__ + "static/media/DominosPizza.58886f3d.svg";